"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var Icon_1 = __importDefault(require("../../../Icon")); // TODO: will use the width from our theme once we finalise it


var AFFIX_WIDTH = '56px';
exports.StyledTextInput = styled_components_1.default.input(function (_a) {
  var theme = _a.theme,
      isDirty = _a.isDirty,
      hasPrefix = _a.hasPrefix,
      hasSuffix = _a.hasSuffix;
  var textInput = theme.components.textInput;
  return {
    // '[type=number]': {
    // },
    '-moz-appearance': 'textfield',
    '::placeholder': {
      color: textInput.default.color
    },
    ':disabled': {
      backgroundColor: textInput.disabled.backgroundColor,
      borderColor: textInput.disabled.borderColor,
      color: textInput.disabled.color,
      cursor: 'not-allowed'
    },
    ':focus': {
      boxShadow: isDirty ? textInput.dirty.shadow : textInput.default.shadow,
      outline: 0,
      zIndex: 100
    },
    ':valid': {
      borderColor: isDirty ? textInput.dirty.color : textInput.valid.color,
      backgroundColor: isDirty ? textInput.dirty.backgroundColor : textInput.valid.backgroundColor,
      color: isDirty ? textInput.dirty.color : textInput.valid.color
    },
    ':focus:valid': {
      boxShadow: isDirty ? textInput.dirty.shadow : textInput.valid.shadow
    },
    border: textInput.default.borderWidth + "  solid " + (isDirty ? textInput.dirty.borderColor : textInput.default.borderColor),
    '::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    borderRadius: textInput.default.borderRadius,
    boxSizing: 'border-box',
    color: isDirty ? textInput.dirty.color : textInput.default.color,
    fontFamily: theme.fontText,
    fontSize: textInput.default.fontSize,
    padding: textInput.default.padding,
    paddingLeft: hasPrefix ? AFFIX_WIDTH : textInput.default.padding,
    paddingRight: hasSuffix ? AFFIX_WIDTH : textInput.default.padding,
    position: 'relative',
    height: textInput.default.height,
    width: '100%'
  };
});
exports.InputWrapper = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    margin: ", ";\n    width: 100%;\n\n    display: inline-block;\n"], ["\n    position: relative;\n    margin: ", ";\n    width: 100%;\n\n    display: inline-block;\n"])), function (_a) {
  var theme = _a.theme,
      tight = _a.tight;
  return tight ? 0 : theme.component.margin + " 0px";
});
var Affix = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: 50%;\n    width: ", ";\n    z-index: 200;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n"], ["\n    cursor: pointer;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: 50%;\n    width: ", ";\n    z-index: 200;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n"])), AFFIX_WIDTH);
exports.Prefix = styled_components_1.default(Affix)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    left: 1px;\n"], ["\n    left: 1px;\n"])));
exports.Suffix = styled_components_1.default(Affix)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    right: 1px;\n"], ["\n    right: 1px;\n"])));
exports.CancelIcon = styled_components_1.default(Icon_1.default).attrs(function (_a) {
  var theme = _a.theme;
  return {
    color: theme.color.disabled,
    size: 'small',
    name: 'round-cross'
  };
})(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;